/* eslint-disable ember/classic-decorator-hooks, ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class GoalsRoute extends Route {
  // Services
  @service
  router;

  @service
  store;

  model() {
    return hash({
      subjects: this.store.findAll('goals/subject'),
      milestones: this.store.query('milestones/milestone', {
        progressionType: ProgressionType.PROGRESSION,
      }),
      milestoneSets: this.store.findAll('milestones/milestone-set'),
      expectations: this.store.findAll('milestones/expectation'),
    });
  }

  init() {
    super.init(...arguments);

    this.router.on('routeDidChange', (transition) => {
      if (transition.to.find((route) => route.name === this.routeName)) {
        // Set activeSubject on the controller so that it can highlight the correct button.
        let subjectId = this.paramsFor('goals.subject').subject_id;
        this.controller.set('activeSubject', subjectId);
      }
    });
  }
}
